export default "__VITE_ASSET__6d41cf5b__"